import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import {
  AddressAutocompleteDirective,
  SecurableResourceDirective,
} from './directives';
import { MaterialModule } from './material.module';
import { PipesModule } from './pipes/pipes.module';
import {
  AmendmentUploadComponent,
  BannerComponent,
  ColumnMappingComponent,
  ContentContainerComponent,
  ContentContainerTitleComponent,
  DataTableComponent,
  EmptyComponent,
  FieldMappingComponent,
  FileUploadComponent,
  FormErrorsComponent,
  FparBannerComponent,
  FparCardComponent,
  FparCommentComponent,
  FparIssueComponent,
  FparSubIssueComponent,
  FparTableCommentsComponent,
  FparTableComponent,
  FparTableIssuesComponent,
  IssueOnHoldPanelComponent,
  MyGrantsFilterComponent,
  NumberInputComponent,
  PageLoaderComponent,
  PasswordErrorComponent,
  ReviewStatusBoxComponent,
  SubmissionClosedComponent,
  SubmissionCommentComponent,
  SupplementalInfoComponent,
  UploadStatusComponent,
  UserGrantListComponent,
  ValidationWarningsComponent,
  ViewIssueLinkComponent,
} from './ui';
import {
  ConfirmDialogComponent,
  IdleTimeoutDialogComponent,
  InactiveUserDialogComponent,
  NotAvailableDialogComponent,
  SelectUserGrantDialogComponent,
} from './ui/dialogs';

const COMPONENTS = [
  AmendmentUploadComponent,
  ColumnMappingComponent,
  ConfirmDialogComponent,
  InactiveUserDialogComponent,
  ContentContainerComponent,
  ContentContainerTitleComponent,
  DataTableComponent,
  EmptyComponent,
  FieldMappingComponent,
  FileUploadComponent,
  FparBannerComponent,
  FparCardComponent,
  FparTableComponent,
  FparTableCommentsComponent,
  FparTableIssuesComponent,
  IdleTimeoutDialogComponent,
  IssueOnHoldPanelComponent,
  MyGrantsFilterComponent,
  NotAvailableDialogComponent,
  NumberInputComponent,
  PageLoaderComponent,
  PasswordErrorComponent,
  SelectUserGrantDialogComponent,
  SecurableResourceDirective,
  SubmissionClosedComponent,
  SubmissionCommentComponent,
  UserGrantListComponent,
  UploadStatusComponent,
  ValidationWarningsComponent,
  ViewIssueLinkComponent,
];

const STANDALONE_COMPONENTS = [
  AddressAutocompleteDirective,
  BannerComponent,
  FparCommentComponent,
  FparIssueComponent,
  FparSubIssueComponent,
  ReviewStatusBoxComponent,
  FormErrorsComponent,
  SupplementalInfoComponent,
];

const MODULES = [
  CommonModule,
  FormsModule,
  MarkdownModule.forRoot(),
  MaterialModule,
  PipesModule,
  ReactiveFormsModule,
  RouterModule,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [...MODULES, ...STANDALONE_COMPONENTS],
  exports: [
    FormsModule,
    MarkdownModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    ...COMPONENTS,
    ...STANDALONE_COMPONENTS,
  ],
  providers: [{ provide: MatDialogRef, useValue: {} }, DatePipe],
})
export class SharedModule {}
